export const CHART_INDICATORS_STORAGE_KEYS = {
  CORE: 'mt6_chart_indicators_core'
} as const;
